var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErtha(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.857 15.36v-5.074H3.43L3.93 9H6.3l-.077 1.286h-1.08v1.285h.951l-.072 1.286h-.879v1.286H6.3l-.056 1.028c-.852.052-1.542.116-2.387.189m16.715.069L19.749 9h-2.152l-.501 1.286h.566l-.72 4.855l1.234.078l.103-.648h1.033l.115.742c.425.034.725.073 1.145.116m-1.775-4.423l.343 2.28h-.686z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9.913 15l-.45-1.56a1.4 1.4 0 0 0 .394-1.011v-2.1c0-.472-.103-.806-.313-1.012c-.205-.21-.63-.313-1.105-.313H6.81l-.501 1.286h.548v4.852l1.286-.06v-1.368h.214L8.721 15zm-1.389-4.714h-.381v2.143h.386c.025 0 .042-.018.042-.043v-2.057c0-.026-.017-.043-.042-.043z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.714 15.116V9h-1.286v3h-.857V9h-1.328l-.386 1.286V9h-2.773l-.227 1.286h.857V15H12v-4.714h1.286V15h1.285v-2.143h.857v2.203q.645.024 1.286.056"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErtha);
export default __webpack_public_path__ + "static/media/ertha.3a7eaaffd791758d170355c1b3421582.svg";
export { ForwardRef as ReactComponent };